export const SET_SESSION_DATA = '@session/SET_SESSION_DATA'
export const CLEAR_SESSION_DATA = '@session/CLEAR_SESSION_DATA'

export const SET_TOKEN = '@session/SET_TOKEN'

export const GET_USER_DATA = '@session/GET_USER_DATA'
export const GET_USER_DATA_FAILURE = '@session/GET_USER_DATA_FAILURE'
export const GET_USER_DATA_SUCCESS = '@session/GET_USER_DATA_SUCCESS'
